import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

// Add a request interceptor to include the user object in the X-User header
api.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem('user');
    if (user) {
      config.headers['X-User'] = user;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const login = (username, password) => api.post('/login', { username, password });

export const getExercises = () => api.get('/exercises');
export const getExercise = (id) => api.get(`/exercises/${id}`);
export const getLatestExerciseLog = (id) => api.get(`/exercises/${id}/latest-log`);
export const getLastSessionExerciseLogs = (id, excludeSessionId = null) => {
  let url = `/exercises/${id}/last-session-logs`;
  if (excludeSessionId) {
    url += `?exclude_session_id=${excludeSessionId}`;
  }
  return api.get(url);
};
export const createExercise = (data) => api.post('/exercises', data);
export const updateExercise = (id, data) => api.post(`/exercises/${id}`, data);
export const deleteExercise = (id) => api.delete(`/exercises/${id}`);

export const getRoutines = () => api.get('/routines');
export const getRoutine = (id = null, dayOfWeek = null) => {
  let url = '/routine';
  const params = [];
  if (id) params.push(`id=${id}`);
  if (dayOfWeek !== null) params.push(`day_of_week=${dayOfWeek}`);
  if (params.length > 0) url += `?${params.join('&')}`;
  return api.get(url);
};
export const updateRoutine = (data) => api.post('/routine', data);
export const deleteRoutine = (id) => api.delete(`/routine?id=${id}`);

export const logWorkoutStep = (data) => api.post('/workout-logs', data);
export const deleteWorkoutSession = (globalSessionId) => api.delete(`/workout-logs/${globalSessionId}?type=session`);
export const updateWorkoutLog = (id, data) => api.post(`/workout-logs/${id}`, data);
export const updateWorkoutSession = (id, data) => api.post(`/workout-logs/${id}?type=session`, data);
export const deleteWorkoutLog = (id, type = null) => {
  const url = type ? `/workout-logs/${id}?type=${type}` : `/workout-logs/${id}`;
  return api.delete(url);
};
export const getLatestWorkouts = () => api.get('/workout-logs/latest');
export const getAllWorkouts = (globalSessionId = null) => {
  const url = globalSessionId ? `/workout-logs?global_session_id=${globalSessionId}` : '/workout-logs';
  return api.get(url);
};

export const getBodyStats = () => api.get('/body-stats');
export const logBodyStats = (data) => api.post('/body-stats', data);
export const updateBodyStats = (id, data) => api.post(`/body-stats/${id}`, data);
export const deleteBodyStats = (id) => api.delete(`/body-stats/${id}`);
export const renameBodyStatField = (oldLabel, newLabel, newUnit) => api.post('/body-stats/rename-field', { oldLabel, newLabel, newUnit });

export const getYoutubePlaylist = () => api.get('/youtube-playlist');
export const updateYoutubePlaylist = (playlist) => api.post('/youtube-playlist', { playlist });

export const downloadDb = (format = 'sqlite') => api.get(`/db/download?format=${format}`, { responseType: 'blob' });
export const uploadDb = (formData) => api.post('/db/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

export default api;
